import { CurrentUser } from "react-current-user";

export const isClient= (user?: CurrentUser | null) => {
    return ["client", "business", "domestic_employer"].includes(user?.type || "")
}